export default __webpack_public_path__ + "static/media/ketoworkout@2x.a07e098b.jpg";